import React, { Dispatch, SetStateAction, useRef, useEffect } from 'react';
import { DIGITS_CONTAINER_DATA } from '../../flows/login/constants';

const {
  DIGIT_CONTAINER: { FILLED_INPUT, VALIDATION_FAILED, LOADING_IN_PROCESS, INITIAL_FRAMES },
} = DIGITS_CONTAINER_DATA;

interface IProps {
  handleInsertDigit: (event: React.ChangeEvent<HTMLInputElement>, digitIndex: number) => void;
  handleRemoveDigit: (event: React.KeyboardEvent<HTMLInputElement>, digitIndex: number) => void;
  onClick: () => void;
  className: string;
  digitIndex: number;
  value: string;
  validationFailed: boolean;
  isLoading: boolean;
  isFocus: boolean;
  otpRequestSent: { requestSent: boolean; setRequestSent: Dispatch<SetStateAction<boolean>> };
  id: string;
}

const DigitContainer = ({
  handleInsertDigit,
  handleRemoveDigit,
  onClick,
  className,
  digitIndex,
  value,
  validationFailed,
  isLoading,
  isFocus,
  otpRequestSent,
  id,
}: IProps) => {
  const inputReference = useRef<HTMLInputElement>(null);
  const { requestSent, setRequestSent } = otpRequestSent;

  useEffect(() => {
    if (inputReference.current && isFocus) {
      inputReference.current.focus();
    }
  }, [isFocus]);

  const setFrameColor = () => {
    if (value && !requestSent) {
      return FILLED_INPUT;
    }
    if (requestSent && validationFailed && !isLoading) {
      return VALIDATION_FAILED;
    }
    if (isLoading) {
      return LOADING_IN_PROCESS;
    }
    return INITIAL_FRAMES;
  };

  return (
    <input
      id={id}
      ref={inputReference}
      value={value}
      disabled={isLoading}
      key={`input${digitIndex}`}
      tabIndex={digitIndex}
      onChange={(e) => {
        handleInsertDigit(e, digitIndex);
      }}
      onKeyDown={(e) => {
        handleRemoveDigit(e, digitIndex);
      }}
      onFocus={() => {
        setRequestSent(false);
      }}
      onClick={onClick}
      type='text'
      className={`${className} ${setFrameColor()}`}
      maxLength={1}
      autoComplete='off'
    />
  );
};

export default DigitContainer;
